import {
  AlianzaBannerRow,
  AlianzaBannersResponse,
  AlianzaEstrategica,
} from './perfil-alianza.model';
import {
  ALIANZA_SLOT,
  AlianzaGrupo,
  agruparFilasAlianza,
} from './perfil-alianza.slots';

export function normalizeAlianzaBannerRows(
  response: AlianzaBannersResponse | null | undefined
): AlianzaBannerRow[] {
  if (!response?.exitoso || !response.banners?.length) {
    return [];
  }

  const first = response.banners[0] as unknown;
  if (Array.isArray(first)) {
    return (response.banners as AlianzaBannerRow[][]).flat();
  }

  return response.banners as AlianzaBannerRow[];
}

/** Agrupa filas Estrategico (CARD + bullets + landing) en alianzas publicables. */
export function mapAlianzasDesdeBanners(rows: AlianzaBannerRow[]): AlianzaEstrategica[] {
  return agruparFilasAlianza(rows)
    .map(mapAlianzaGrupo)
    .filter(esAlianzaPublicable);
}

function mapAlianzaGrupo(grupo: AlianzaGrupo): AlianzaEstrategica {
  const card = grupo.porSlot.CARD;
  const landing = grupo.porSlot.LANDING;
  const cta = grupo.porSlot.LCTA;

  const bullets = [grupo.porSlot.CB1, grupo.porSlot.CB2, grupo.porSlot.CB3, grupo.porSlot.CB4]
    .map((fila) => trim(fila?.contenido))
    .filter(Boolean)
    .slice(0, 4);

  const landingBullets = [grupo.porSlot.LB1, grupo.porSlot.LB2, grupo.porSlot.LB3]
    .map((fila) => ({
      texto: trim(fila?.contenido),
      urlIcono: trim(fila?.urlArchivo),
    }))
    .filter((b) => !!b.texto)
    .slice(0, 3);

  return {
    idBanner: Number(card?.idBanner) || 0,
    urlLogo: trim(card?.urlArchivo),
    nombre: firstNonEmpty(card?.titulo, card?.nombreArchivo),
    descripcion: trim(card?.contenido),
    bullets,
    nombreBoton: trim(card?.nombreBoton),
    urlForward: firstNonEmpty(card?.urlForward, cta?.urlForward),
    landingTitulo: trim(landing?.titulo),
    landingDescripcion: trim(landing?.nombreBoton),
    landingLogo: firstNonEmpty(landing?.urlArchivo, card?.urlArchivo),
    landingDetalle: trim(landing?.contenido),
    landingBullets,
    landingNombreBoton: firstNonEmpty(cta?.nombreBoton, card?.nombreBoton),
    landingUrlForward: firstNonEmpty(cta?.urlForward, card?.urlForward),
    textoOmitir: trim(cta?.contenido),
  };
}

function esAlianzaPublicable(alianza: AlianzaEstrategica): boolean {
  return !!(
    alianza.nombre
    && alianza.descripcion
    && alianza.nombreBoton
    && alianza.urlForward
  );
}

function firstNonEmpty(...values: Array<string | null | undefined>): string {
  for (const value of values) {
    const t = trim(value);
    if (t) {
      return t;
    }
  }
  return '';
}

function trim(value: string | null | undefined): string {
  return (value ?? '').trim();
}
